module.exports = __webpack_public_path__ + "img/cate-6-7ed2ee.png";